module.exports = __webpack_public_path__ + "img/mbanner3_tv.30c8c715.jpg";